import { render } from "./CuatroXMil.vue?vue&type=template&id=c5ec1770"
import script from "./CuatroXMil.vue?vue&type=script&lang=js"
export * from "./CuatroXMil.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__